/// <reference path="../../../../tools/typings/tsd.d.ts"/>

module DealerwareWebContent {

    "use strict";
    import IDealerwareEmployee = DealerwareWebServices.IDealerwareEmployee;

    var isFunction  = angular.isFunction;

    export interface IEmployeeDetailsController {
        employee : IDealerwareEmployee;
        roles: any;

        loadEmployee(id: number) : void;
        loadRoles() : void;
    }

    export class EmployeeDetailController implements IEmployeeDetailsController {
        public static $inject : string[] = [
            '$q',
            '$timeout',
            '$state',
            '$stateParams',
            '$dealerwareEmployeeFactory',
            'CurrentUser',
            '$mobilityCompanyAuthentication',
            'DealerwareRoleCollection',
            '$dealerwareNotification',
            '$dealerwareLoading'
        ];

        public employee : IDealerwareEmployee;
        public roles: any;

        constructor(public $q: any,
                    public $timeout : any,
                    public $state: any,
                    public $stateParams : any,
                    public $dealerwareEmployeeFactory : any,
                    public CurrentUser : any,
                    public $auth: any,
                    public DealerwareRoleCollection: any,
                    public $dealerwareNotification: any,
                    public $dealerwareLoading: any) {

            if (this.$stateParams.hasOwnProperty('employeeId')) {
                this.loadEmployee(this.$stateParams.employeeId);
            } else {
                this.$dealerwareNotification.error('No employee id');
            }
        }

        public get hideRolesTab() : boolean {
            if (this.employee && this.employee.accountSettings) {
                return !this.CurrentUser.user.hasRole('user_role_manager') || !this.employee.accountSettings.data.active
            }
            return true;
        }

        public loadEmployee(id : number) : void {
            var _self = this;
            this.employee = undefined;

            if (this.$stateParams.hasOwnProperty('employeeId')) {
                var loader = this.$dealerwareLoading.show("Loading Employee...");

                _self.$dealerwareEmployeeFactory.loadEmployee(this.$auth.location.id, _self.$stateParams.employeeId).then(
                    function(response : any) { _self.employee = response.employee; },
                    function(response: any) { _self.$dealerwareNotification.apiError(response); }
                ).finally(function() { loader.close(); });
            } else {
                this.$dealerwareNotification.error("No employee to load");
            }
        }

        public loadRoles() : void {
            var _self = this;

            if (!this.roles) {
                var loader = this.$dealerwareLoading.show("Loading...");
                this.DealerwareRoleCollection.index({
                    promise: true,
                    params: {
                        location_id: this.$auth.location.id
                    }
                }).then(
                    function(returnValue : any, response : any) {
                        _self.roles = returnValue;

                        _self.employee.accountSettings.data.roles_mapped.forEach(function(userRole: any) {
                            _self.roles.data.forEach(function(role: any) {
                                if (role.data.id === userRole.id) {
                                    role.data.selected = true;
                                }
                            });
                        });

                        loader.close();
                    },
                    function(response : any) { loader.close(); }
                );
            }
        }
    }

    getDealerwareWebContentModule().controller('EmployeeDetailsController',EmployeeDetailController);
}
